export default "__VITE_ASSET__GJYNj1Y2__"